import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import exportFromJSON from "export-from-json";
import moment from "moment";
import doc_icon from "../assets/images/doc.png";
import excel_icon from "../assets/images/excel.png";
import gif_icon from "../assets/images/gif_icon.png";
import jpg_icon from "../assets/images/jpg_icon.png";
import pdf_icon from "../assets/images/pdf.png";
import png_icon from "../assets/images/png_icon.png";
import file from "../assets/images/file.png";
import video_icon from "../assets/images/video.png";
import psd_icon from "../assets/images/psd_icon.png";

export const sleep = async (timeout) =>
  new Promise((resolve) => setTimeout(resolve, timeout));

export const showDeleteAlert = async ({
  text = "",
  title = "",
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
  icon = "success",
}) => {
  try {
    const MySwal = withReactContent(Swal);
    const result = await MySwal.fire({
      title,
      text,
      icon,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonColor: "#6b7280",
      cancelButtonText,
      confirmButtonText,
      showLoaderOnConfirm: true,
      confirmButtonColor: "#007AFF",
      reverseButtons: true,
      color: "#000000",
    });

    return result.isConfirmed;
  } catch (error) {
    console.error("Error showing delete alert:", error);
    return false;
  }
};

export const showAlert = async ({
  text,
  title,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
}) => {
  try {
    const MySwal = withReactContent(Swal);
    const result = await MySwal.fire({
      title,
      text,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonColor: "#e5e7eb",
      cancelButtonText,
      confirmButtonText,
      showLoaderOnConfirm: true,
      confirmButtonColor: "#007AFF",
      reverseButtons: true,
      color: "#000000",
    });

    return result.isConfirmed;
  } catch (error) {
    console.error("Error showing delete alert:", error);
    return false;
  }
};

export const showLogoutAlert = async ({
  text,
  title,
  confirmButtonText = "Logout",
  cancelButtonText = "Cancel",
}) => {
  try {
    const MySwal = withReactContent(Swal);
    const result = await MySwal.fire({
      title,
      text,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonColor: "#e5e7eb",
      cancelButtonText,
      confirmButtonText,
      showLoaderOnConfirm: true,
      confirmButtonColor: "rgb(220, 53, 69)",
      reverseButtons: false,
      color: "#000000",
    });

    return result.isConfirmed;
  } catch (error) {
    console.error("Error showing logout alert:", error);
    return false;
  }
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const formatDate = (date) => {
  const now = moment();
  const diffMinutes = now.diff(date, "minutes");

  const isSameDay = now.isSame(date, "day");

  const isYesterday = now.subtract(1, "day").isSame(date, "day");

  const isSameYear = now.isSame(date, "year");

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes === 1) {
    return `${diffMinutes} minute ago`;
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minutes ago`;
  } else if (isSameDay) {
    return `Today, ${moment(date).format("h:mm A")}`;
  } else if (isYesterday) {
    return `Yesterday, ${moment(date).format("h:mm A")}`;
  } else if (diffMinutes < 10080) {
    return `${moment(date).format("dddd, h:mm A")}`;
  } else if (isSameYear) {
    return `${moment(date).format("MMMM DD, h:mm A")}`;
  } else {
    return `${moment(date).format("MMMM DD, YYYY, h:mm A")}`;
  }
};

export const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  const formattedHours = String(hours).padStart(2, "0");

  return `${year}-${month}-${day} at ${formattedHours}:${minutes} ${ampm}`;
};

export const convertMasterDataToExcel = (data) => {
  return data.map(({ name, type, description, unit, category_name }) => ({
    Category: category_name,
    Title: name,
    Type: type,
    Description: description,
    Unit: unit,
  }));
};

export const downloadReport = (data, fileName, exportType) => {
  exportFromJSON({ data, fileName, exportType });
};

export const getFileType = (filename) => {
  const imageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "svg",
    "webp",
    "tiff",
  ];
  const videoExtensions = [
    "mp4",
    "mkv",
    "mov",
    "avi",
    "wmv",
    "flv",
    "webm",
    "m4v",
  ];

  // Extract file extension
  const ext = filename.split(".").pop().toLowerCase();

  if (imageExtensions.includes(ext)) {
    return "image";
  } else if (videoExtensions.includes(ext)) {
    return "video";
  } else {
    return ""; // Not an image or video
  }
};

export const getFileIcon = (fileName) => {
  const extension = fileName.split(".")?.pop()?.toLowerCase() || "";

  const icons = {
    doc: doc_icon,
    docx: doc_icon,
    xls: excel_icon,
    xlsx: excel_icon,
    gif: gif_icon,
    jpg: jpg_icon,
    jpeg: jpg_icon,
    pdf: pdf_icon,
    png: png_icon,
    file: file,
    psd: psd_icon
    
  };

  const fileTypeIons = {
    "application/msword": doc_icon, // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": doc_icon, // .docx
    "application/vnd.ms-excel": excel_icon, // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": excel_icon, // .xlsx
    "application/pdf": pdf_icon,
    "image/jpeg": jpg_icon,
    "image/jpg": jpg_icon,
    "image/png": png_icon,
    "image/gif": gif_icon,
    "image/bmp": jpg_icon,
    "image/webp": jpg_icon,
    "image/svg+xml": jpg_icon,
    "image/tiff": jpg_icon,
    "image/x-icon": jpg_icon,
    "image/heic": jpg_icon,
    "video/mp4": video_icon,
    "video/webm": video_icon,
    "video/ogg": video_icon,
    "video/ogv": video_icon,
    "video/x-msvideo": video_icon, // .avi
    "video/x-ms-wmv": video_icon, // .wmv
    "video/quicktime": video_icon, // .mov
    "video/mpeg": video_icon, // .mpeg
    "video/3gpp": video_icon, // .3gp
    "video/3gpp2": video_icon, // .3g2
    "application/x-photoshop": psd_icon,
    "image/vnd.adobe.photoshop": psd_icon, 
     default: file,
  };
  

  return icons[extension] || fileTypeIons[fileName] || file;
};

export const units = [
  {
    label: "Currency",
    value: "Currency",
  },
  {
    label: "Percentage",
    value: "Percentage",
  },
  {
    label: "Length",
    value: "Length",
  },
  {
    label: "Time",
    value: "Time",
  },
  {
    label: "Weight",
    value: "Weight",
  },
  {
    label: "Volume",
    value: "Volume",
  },
  {
    label: "Temperature",
    value: "Temperature",
  },
  {
    label: "Speed",
    value: "Speed",
  },
  {
    label: "Area",
    value: "Area",
  },
  {
    label: "Energy",
    value: "Energy",
  },
  {
    label: "Pressure",
    value: "Pressure",
  },
  {
    label: "Power",
    value: "Power",
  },
  {
    label: "Frequency",
    value: "Frequency",
  },
  {
    label: "Date",
    value: "Date",
  },
];

export const tabs = ["Master Table", "Request", "Validation History"];
export const value_type = [
  {
    label: "Alphanumeric",
    value: "Alphanumeric",
  },
  {
    label: "Numeric",
    value: "Numeric",
  },
  {
    label: "Alphabetic",
    value: "Alphabetic",
  },
  {
    label: "Date US Format",
    value: "Date US Format",
  },
];

export const FILE_TYPES = {
  DOC_TYPES: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/postscript",
    "application/x-photoshop",
    "vnd.adobe.photoshop"
  ],
  IMAGE_TYPES: [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/svg+xml",
    "image/webp",
    "image/tiff",
    "image/vnd.adobe.photoshop",
    "image/heif",
    "image/jp2",  
    "image/vnd.adobe.photoshop"
  ],
  VIDEO_TYPES: [
    "video/mp4",
    "video/x-matroska",
    "video/mkv", 
    "video/quicktime",
    "video/x-msvideo",
    "video/avi", 
    "video/x-ms-wmv",
    "video/x-flv",
    "video/webm",
    "video/x-m4v",
    "video/3gpp",
    "video/x-ms-asf",
    "video/ogg",
    "video/mp2t",
    "video/dvd",
    "video/x-f4v",
    "application/vnd.rn-realmedia",  
  ],
} 

export const FILE_SIZE = {
  DOC_MAX_SIZE: 100 * 1024 * 1024,
  IMAGE_MAX_SIZE: 100 * 1024 * 1024,
  VIDEO_MAX_SIZE: 250 * 1024 * 1024,
}

export const fileMonths = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const addFolderRoles = [
  "head_office", 
  "agency_admin",
  "account_managers",
  "SuperAdmin"
];
export const agencyUserRoles = [
  "agency_user", 
  "agency_admin",
  "account_managers"
];